import React, { useMemo } from 'react';
import { Text, View } from 'react-native';
import { useCurrency, useTranslation } from '@oolio-group/localization';
import { getStyles } from '../../screens/PaymentScreen/PaymentConfirmation/PaymentConfirmation.styles';
import { useTheme } from '../../hooks/useTheme';
import IconStatus from '../Icon/IconStatus';
import { Media } from '../Media/Media';
import useBehaviorSubjectState from '../../hooks/rxjs/useSubjectState';
import { sessionSubject } from '../../state/sessionObservable';
import { resolveBrandColor } from '../../utils/branding';

export interface BalancePaymentCompleteViewProps {
  testID?: string;
  amount?: number;
}

/**
 * An account balance payment has no order, so there is no receipt to send.
 * Same panel as PaymentConfirmation with the receipt prompt left off.
 */
const BalancePaymentCompleteView: React.FC<BalancePaymentCompleteViewProps> = ({
  testID = 'balance-payment-complete-view',
  amount = 0,
}) => {
  const { colors } = useTheme();
  const styles = useMemo(() => getStyles(colors), [colors]);
  const { formatCurrency } = useCurrency();
  const { translate } = useTranslation();
  const { value: session } = useBehaviorSubjectState(sessionSubject);

  const display = session?.device?.deviceProfile?.customerDisplay;

  return (
    <View
      testID={testID}
      style={[
        styles.container,
        { backgroundColor: resolveBrandColor(display?.brandColor) },
      ]}
    >
      <Media config={display?.idleScreen} />
      <View style={styles.content}>
        <View style={styles.lhs}>
          <View style={styles.header}>
            <IconStatus name="success" />
            <Text style={styles.title}>
              {translate('cdsPaymentScreen.paymentComplete')}
            </Text>
          </View>
          <View style={styles.text}>
            <Text style={styles.label}>
              {translate('cdsPaymentScreen.amountPaid')}
            </Text>
            <Text style={styles.amount} testID="payment-amount">
              {formatCurrency(amount)}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default BalancePaymentCompleteView;
